export const TokenConstants = {
  SET_TOKEN_INFO: 'SET_TOKEN_INFO',
  DELETE_TOKEN_INFO: 'DELETE_TOKEN_INFO',
  SET_INITIAL_DISPLAY_TOKENS: 'SET_INITIAL_DISPLAY_TOKENS',
  SET_CURRENT_DISPLAY_TOKEN: 'SET_CURRENT_DISPLAY_TOKEN',
  SET_COUNTER_NUMBER: 'SET_COUNTER_NUMBER',
  SET_COUNTER_CATEGORY: 'SET_COUNTER_CATEGORY',
  INVITE_CUSTOMER: 'INVITE_CUSTOMER',
  SET_MACHINE_ID: 'SET_MACHINE_ID',
  SET_AVG_SERVICE_TIME: 'SET_AVG_SERVICE_TIME',
}
